<template>
    <div>
        <h1>Email Settings</h1>
    </div>
    <div v-if="!loading" class="left">
        <div class="na-form">
            <DxTabPanel>
                <DxItem :title="tx.TabBasis">
                    <div class="dx-fieldset">
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.SmtpServer}}</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='record.SmtpServer' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.SmtpPort}}</div>
                            <div class="dx-field-value">
                                <DxNumberBox v-model:value='record.SmtpPort' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.UseSSL}}</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='record.UseSSL' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.UserName}}</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='record.UserName' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.Password}}</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='record.Password' mode="password"/>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.UseCertificate}}</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='record.UseCertificate' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.CertSerialNumber}}</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='record.CertSerialNumber' />
                            </div>
                        </div>
                    </div>
                </DxItem>
            </DxTabPanel>
            <div class="na-buttons-row">
                <div>
                    <DxButton :text="btn.BtnSave"
                              :type="saveButtonType"
                              :disabled="saveButtonDisabled"
                              styling-mode="contained"
                              @click="onSave($event)" />
                </div>
                <div>
                    <DxButton :text="btn.BtnSendTestMail"
                              type="default"
                              styling-mode="contained"
                              @click="onTestMail()" />
                </div>
                <div>
                    <DxButton :text="btn.BtnCancel"
                              type="default"
                              styling-mode="outlined"
                              @click="onCancel()" />
                </div>
            </div>
        </div>
    </div>

    <DxPopup v-model:visible="popup.Visible" :title="popup.Title" :width="700" height="auto" :content-template="popup.Template">
        <template #sendTestMail>
            <div class="puBox">
                <div class="puCell">
                    <div class="puLabel">{{ tx.EmailReceiver}}</div>
                    <div class="puValue">
                        <DxTextBox v-model:value="mail.Receiver"></DxTextBox>
                    </div>
                </div>
                <div class="puCell">
                    <div class="puLabel">{{ tx.EmailSubject}}</div>
                    <div class="puValue">
                        <DxTextBox v-model:value="mail.Subject"></DxTextBox>
                    </div>
                </div>
                <div class="puCell">
                    <div class="puLabel">{{ tx.EmailBody}}</div>
                    <div class="puValue">
                        <DxTextArea v-model:value="mail.Body"></DxTextArea>
                    </div>
                </div>
                <div class="puButtons">
                    <div class="puLeftButtons">
                        <DxButton :text="btn.CancelMail" @click="hidePopup" />
                    </div>
                    <div class="puRightButtons">
                        <DxButton :text="btn.SendMail" @click="sendMail" />
                    </div>
                </div>
            </div>
        </template>
    </DxPopup>
</template>
<script>
    import axios from "axios";
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import { DxTextBox } from 'devextreme-vue/text-box';
    import { DxTextArea } from 'devextreme-vue/text-area';
    import { DxNumberBox } from 'devextreme-vue/number-box';
    import { DxButton } from 'devextreme-vue/button';
    import { DxPopup } from 'devextreme-vue/popup';

    const baseUri = "WebApi.asmx/api/setting";

    export default {

        name: 'EmailConfirmation',
        components: {
            DxCheckBox, DxTextBox, DxNumberBox, DxButton, DxPopup, DxTextArea
        },
        data() {
            return {
                record: [],
                loading: true,
                mail: {
                    Receiver: "",
                    Subject: "Test",
                    Body: "Test"
                },
                popup: {
                    Visible: false,
                    Title: "",
                    Template: ""
                },
                tx: {
                    SmtpServer: this.$LanguageProvider.GetResource("SmtpServer", "Caption", "Server"),
                    SmtpPort: this.$LanguageProvider.GetResource("SmtpPort", "Caption", "Port"),
                    UseSSL: this.$LanguageProvider.GetResource("UseSSL", "Caption", "Use SSL"),
                    UserName: this.$LanguageProvider.GetResource("UserName", "Caption", "Username"),
                    Password: this.$LanguageProvider.GetResource("Password", "Caption", "Password"),
                    UseCertificate: this.$LanguageProvider.GetResource("UseCertificate", "Caption", "Use Email Certificate"),
                    CertSerialNumber: this.$LanguageProvider.GetResource("CertSerialNumber", "Caption", "Certificate Serial Number"),
                    EmailReceiver: this.$LanguageProvider.GetResource("EmailReceiver", "Caption", "Receiver"),
                    EmailSubject: this.$LanguageProvider.GetResource("EmailSubject", "Caption", "Subject"),
                    EmailBody: this.$LanguageProvider.GetResource("EmailBody", "Caption", "Message"),
                    PopupSendMailTitle: ("PopupSendMail", "Title", "Send Test Mail"),
                },
                btn: {
                    BtnSave: this.$LanguageProvider.GetResource("BtnSave", "Caption", "Update"),
                    BtnSendTestMail: this.$LanguageProvider.GetResource("BtnSendTestMail", "Caption", "Send Test Mail"),
                    BtnCancel: this.$LanguageProvider.GetResource("BtnCancel", "Caption", "Cancel"),
                    CancelMail: this.$LanguageProvider.GetResource("CancelMail", "Caption", "Cancel"),
                    SendMail: this.$LanguageProvider.GetResource("SendMail", "Caption", "Send Mail"),
                }
            }
        },
        mounted() {
            this.loadData().then(() => {
                this.loading = false;
            });
        },
        computed: {
        },
        methods: {
            loadData() {
                return axios
                    .get(baseUri + '/GetEmailSettings')
                    .then(res => {
                        if (res.data.success) {
                            this.record = res.data.data;
                        }
                        else {
                            alert(`error: ${res.data.errorMessage}`)
                        }
                    })
            },
            onSave() {
                var formData = new FormData();
                formData.append("data", JSON.stringify(this.record));
                return axios
                    .post(baseUri + '/UpdateEmailSettings', formData)
                    .then(res => {
                        if (!res.data.success) {
                            alert(`error: ${res.data.errorMessage}`)
                        }
                        return res;
                    });
            },
            onCancel() {
                window.location.href = window.location.pathname + "?action=cancel";
            },
            onTestMail() {
                this.loading = true;
                this.onSave().then(res => {
                    if (res.data.success) {
                        this.loading = false;
                        this.popup.Template = "sendTestMail";
                        this.popup.Title = this.tx.PopupSendMailTitle;
                        this.popup.Visible = true;
                    }
                });
            },
            cancelMail() {
                this.popup.Visible = false;
            },
            sendMail() {
                var formData = new FormData();
                formData.append("receiver", this.mail.Receiver);
                formData.append("subject", this.mail.Subject);
                formData.append("body", this.mail.Body);
                return axios
                    .post(baseUri + '/SendTestMail', formData)
                    .then(res => {
                        if (res.data.success) {
                            alert(`Mail succesfully sent`);
                        }
                        else {
                            alert(`error: ${res.data.errorMessage}`);
                        }
                        return res;
                    });

            },
            hidePopup() {
                this.popup.Visible = false;
            }
        }
    }
</script>
<style scoped>
    .puBox {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .puButtons {
        display: flex;
        justify-content: space-between;
    }

    div#app h1 {
        font-size: 20px;
    }
</style>